import appendCredentials from '@/utils/appendCredentials'
import getBasePath from '@/utils/path'
import { PortalApiUser, LegacyApi } from '@clients/moe-auth-proxy' // eslint-disable-line no-unused-vars
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars

let basePath = getBasePath() + '/moe-auth'

export default class ExtendedLegacyApi extends LegacyApi {
  public legacyGetUser3 (options?: any): AxiosPromise<PortalApiUser> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.legacyGetUser3(optionsParam)
  }
}
